import React, { useState } from "react";
import { Container } from "../components/ui-kit";
import PageHero from "../components/PageHero";
import { FileText } from "lucide-react";
import { POLICIES, POLICY_INTRO } from "../content/policies";

export default function Legal() {
  const [active, setActive] = useState(POLICIES[0].id);
  const current = POLICIES.find((p) => p.id === active) || POLICIES[0];

  return (
    <div>
      <PageHero label="Legal Centre" title="Legal & Policies" subtitle="All policies are versioned with an effective date and last-updated date, and are editable via the CMS." crumbs={[{ label: "Legal" }]} />
      <section className="bg-white">
        <Container className="grid gap-10 py-16 lg:grid-cols-[320px_1fr]">
          <aside className="lg:sticky lg:top-28 lg:self-start">
            <div className="max-h-[72vh] overflow-y-auto rounded-2xl border border-emerald-900/10 bg-sand p-3 no-scrollbar">
              {POLICIES.map((p, i) => (
                <button key={p.id} id={p.id} onClick={() => setActive(p.id)} data-testid={`policy-${p.id}`} className={`block w-full scroll-mt-28 rounded-lg px-3 py-2 text-start text-sm font-medium transition ${active === p.id ? "bg-emerald-900 text-white" : "text-slate-600 hover:bg-emerald-50 hover:text-emerald-900"}`}>
                  <span className="me-1.5 text-xs opacity-50">{String(i + 1).padStart(2, "0")}</span>{p.title}
                </button>
              ))}
            </div>
          </aside>
          <div>
            <p className="mb-6 rounded-2xl border border-gold/30 bg-gold-soft p-5 text-sm leading-relaxed text-emerald-900">{POLICY_INTRO}</p>
            <div className="rounded-2xl border border-emerald-900/10 bg-white p-8">
              <div className="flex flex-wrap items-center justify-between gap-3 border-b border-emerald-900/10 pb-5">
                <h2 className="flex items-center gap-2 font-display text-3xl font-bold text-emerald-900"><FileText className="h-6 w-6 text-gold" /> {current.title}</h2>
                <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800">v1.0 · Effective {new Date().getFullYear()}</span>
              </div>
              <div className="mt-6 space-y-4">
                {current.body.map((para, i) => <p key={i} className="leading-relaxed text-slate-600">{para}</p>)}
              </div>
              <p className="mt-8 border-t border-emerald-900/10 pt-4 text-sm text-slate-400">Helping Hands Global Solutions - FZCO · Last updated: {new Date().toISOString().slice(0, 10)}</p>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
